// Unprotected routes
export const AUTHN = `/v1.0/authn`;
export const COUPONS_ID = id => `/v1.0/coupons/${id}`;
export const PROMOCODE_CODE = code => `/v1.0/promoCode/${code}`;
export const PROJECT_COUNTS = `/v1.0/projects/counts`;
export const PRICING_PLANS = `/v1.0/pricing-plans`;
export const TAX_RATES = `/v1.0/tax-rates`;

// Protected Routes
export const CUSTOMERS = `/v1.0/customers`;
export const CUSTOMERS_ID = id => `/v1.0/customers/${id}`;
export const CUSTOMERS_ME = `/v1.0/customers/me`;
export const ACCOUNTPROJECTS = projectUuid => `/v1.0/accountProjects/${projectUuid}`;
export const PROJECTS_PINNED_COUNTS = `/v1.0/projects/pinned/counts`;
export const PROJECTS_PINNED_EXPORT = `/v1.0/projects/pinned/export`;
export const PROJECTS_SEARCH = `/v1.0/projects/search`;
export const PROJECTS_PREVIEW_SEARCH = 'v1.0/projects/preview/search';
export const SEARCH_PROFILES = '/v1.0/searchProfiles';
export const ORGANIZATIONS_SEARCH = `/v1.0/organizations/external`;
export const PROJECTS_TYPES = `/v1.0/projects/types`;
export const SUBSCRIPTIONS = `/v1.0/subscriptions`;
export const SUBSCRIPTIONS_ID = id => `/v1.0/subscriptions/${id}`;
export const TAXONOMYCODES = `/v1.0/TaxonomyCodes`;
export const TAXONOMYCODES_ID_CHILDREN = id => `/v1.0/TaxonomyCodes/${id}/Children`;
export const VENDORS_ME = `/v1.0/vendors/me`;
export const VENDORS_ME_TAXONOMYCODES = `/v1.0/vendors/me/TaxonomyCodes`;
export const VENDORS_ME_SUBMISSIONS_COUNTS = `/v1.0/vendors/me/submissions/counts`;
export const VENDORS_ME_SUBMISSIONS = `/v1.0/vendors/me/submissions`;
export const VENDORS_ME_CONTRACTS = `/v1.0/vendors/me/contracts`;
export const USERS_ME = '/v1.0/users/me';
export const USERS_ME_SINGLEUSETOKENS = '/v1.0/users/me/singleUseTokens';
export const CONFIRMEMAIL = '/v1.0/confirmEmail';
export const SINGLEUSETOKENS_CHECK = '/v1.0/singleUseTokens/check';
export const COMPLETESETUP = '/v1.0/completeSetup';
export const SINGLEUSETOKENS_REFRESH = '/v1.0/singleUseTokens/refresh';
export const CHANGE_EMAIL = '/v1.0/users/me/email';
export const CHANGE_PASSWORD = `/v1.0/users/me/password`;
export const STRIPECUSTOMERPORTALURL = '/v1.0/stripeCustomerPortalUrl';
// FEATURE_FLAGS is unprotected if USER_ANON provided as userUuid
export const FEATURE_FLAGS = userUuid => `/v1.0/users/${userUuid}/featureFlags`;
export const TIMEZONES = '/v1.0/timezones';
